<template>
  <modal name="yagiprime-carat-dialog" :adaptive="true" :scrollable="true" height="auto">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeDialog" icon="el-icon-circle-close-outline" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div id="renew3_mypage">

      <div class="cs_popup">
        <div class="cs_popup_wrap">
          <div class="flex sp_flex">
            <!--<p class="cs_status_badge">未読</p>-->
            <p class="cs_day">送信日：{{ caratJobInfo.recommended_date }}</p>
          </div>
          <div class="flex joblist_link01">
            <!--<p class="txt_category">正社員</p>-->
            <h4 class="joblist_h4">{{ caratJobInfo.detail_result_json.title }}</h4>
          </div>
          <div class="joblist_link02">
            <p class="joblist_company">{{ caratJobInfo.detail_result_json.company_name }}</p>
            <p class="txt_area">{{ caratJobInfo.search_result_json.cities }}</p>
            <p class="joblist_salary">{{ caratJobInfo.detail_result_json.salary }}</p>
          </div>
          <div class="carat-pop-imgbox">
            <img :src="imgitem" v-for="(imgitem, subindex) in caratJobInfo.detail_result_json.cover_urls" alt="求人イメージ画像"
              class="joblist_img">
          </div>


          <div class="detail_item detail_item_top">
            <p class="detail_title">募集職種</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.job }}</pre>
          </div>

          <div class="detail_item">
            <p class="detail_title">想定年収</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.salary }}</pre>
          </div>

          <div class="detail_item">
            <p class="detail_title">勤務地</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.work_location }}</pre>
          </div>

          <div class="detail_item">
            <p class="detail_title">仕事内容</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.description }}</pre>
          </div>

          <div class="detail_item">
            <p class="detail_title">応募条件、求められるスキル</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.skill }}</pre>
          </div>

          <!--2段目-->
          <div class="detail_item detail_item_top">
            <p class="detail_title">給与・賞与</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.salary }}</pre>
          </div>

          <div class="detail_item">
            <p class="detail_title">勤務時間</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.working_hour }}</pre>
          </div>

          <div class="detail_item">
            <p class="detail_title">待遇・福利厚生</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.welfare }}</pre>
          </div>

          <div class="detail_item">
            <p class="detail_title">休日・休暇</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.working_day }}</pre>
          </div>

          <!--3段目-->
          <div class="detail_item detail_item_top">
            <p class="detail_title">社名</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.company_name }}</pre>
          </div>

          <div class="detail_item">
            <p class="detail_title">本社所在地</p>
            <pre class="detail_pre">{{ caratJobInfo.detail_result_json.company_address }}</pre>
          </div>

        </div>
        <!--固定-->
        <div class="bottom_bar">
          <button type="button" id="send-carat-detail-application" class="el-button el-button--success carat_btn"
            @click="applicantYagiprimeCarat" v-if="!caratJobInfo.applied_date && !caratJobInfo.cancel_date">
            <span>履歴書を提出</span>
          </button>

          <button v-if="!caratJobInfo.applied_date && !caratJobInfo.cancel_date" @click="cancelYagiprimeCarat()"
            class="carat_declinebtn"><span>辞退する</span></button>

          <p>Yagishの<a href="https://rirekisho.yagish.jp/terms" target="_blank">利用規約</a>、<a
              href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a>、<a
              href="https://www.yagish.jp/privacy_policy/" target="_blank">プライバシーポリシー</a><br>Caratの<a
              href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a" target="_blank"
              class="consent-link">プライバシーポリシー</a>
          </p>
          <p><img src="/static/renew_img/check_icon.png" alt="同意する" style="height: 20px;">規約に同意して問い合わせる</p>
        </div>
      </div>
    </div>

  </modal>
</template>

<style scoped>
#renew3_mypage .cs_popup_wrap {
  padding: 20px;
  border: 2px solid #8fbd67;
  border-radius: 10px;
  height: 65vh;
  overflow: scroll;
  margin-top: 10px;
}

#renew3_mypage .cs_popup {
  background-image: linear-gradient(180deg, rgba(255, 225, 0, 0.25), rgba(255, 225, 0, 0));
}

#renew3_mypage .cs_popup .joblist_img {
  width: 48%;
  margin: 0;
}

#renew3_mypage .detail_item {
  margin-top: 20px;
}

#renew3_mypage .detail_item:first-child {
  margin-top: 0;
}

#renew3_mypage .detail_item_top {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #DFDFDF;
}

#renew3_mypage .detail_item_top:first-child {
  border-top: 0;
}

#renew3_mypage .detail_title {
  font-size: 0.8rem;
  font-weight: bold;
  color: #0F9934;
}

#renew3_mypage .detail_pre {
  white-space: pre-wrap;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, YuGothic, "\30D2\30E9\30AE\30CE\89D2\30B4 ProN W3", Hiragino Kaku Gothic ProN, Arial, "\30E1\30A4\30EA\30AA", Meiryo, MyFontFamily, Segoe UI Emoji, Segoe UI Symbol, Apple Color Emoji, Noto Color Emoji, Noto Emoji, sans-serif;
}

#renew3_mypage .bottom_bar {
  text-align: center;
  margin-top: 20px;
}

#renew3_mypage .bottom_bar .carat_btn {
  width: 100%;
  font-size: 1rem;
}

#renew3_mypage .carat_declinebtn {
  margin: 10px 0 30px;
  background: none;
  font-size: 0.8rem;
}

#renew3_mypage .carat-pop-imgbox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}
</style>

<script>
import _ from '@/assets/lib/my-lodash'
export default {
  components: {
  },
  data: function () {
    return {
      caratJobInfo: {},
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      keyword: '',
      area: '',
      previewHtml: '',
      permissionType: 1,
      isSended: false,
      fullscreenLoading: false,
      username: '',
      baite_title: 'バイト',
      age: 0,
      isAgree: true,
      salarylength: 200,
      job_list: [],
      nowStep: 1,
      jod_detail: [],
      search_id: '',
      isMypage: false,
      fromMypage: '',
      isTxtBlock: true
    }
  },
  created: function () {
    const app = this
  },
  computed: {
  },
  methods: {
    openYagiprimeCaratDialog: function (subitem) {
      this.caratJobInfo = subitem
      this.$nextTick(function () {
        this.$modal.show('yagiprime-carat-dialog')
      })

      const formData = new FormData()
      if (this.caratJobInfo.type == 'other_recommender') {
        formData.append('recommended_job_id', this.caratJobInfo.other_recommender_recommended_job_id)

      } else {
        formData.append('recommended_job_id', this.caratJobInfo.recommended_job_id)

      }
      formData.append('type', this.caratJobInfo.type)

      const app = this
      this.$axios
        .post(this.$varuna.endPoints.detailRecommendedJob, formData, { timeout: 60000 })
        .then(function (response) {
          app.caratJobInfo.read_date = '2024'
        })
        .catch(function (error) {
        }).finally(function () {
        })
    },
    closeDialog: function () {
      // console.error('closeDialog')
      this.$modal.hide('yagiprime-carat-dialog')

    },
    applicantYagiprimeCarat: function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.isSended = true
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('job_id', this.caratJobInfo.job_id)
      // formData.append('format_id', this.formatid)
      formData.append('search_id', '')
      formData.append('detail_flag', 'd')
      formData.append('type', this.caratJobInfo.type)

      formData.append('app_flag', this.$site.appFlag)
      formData.append('site_flag', 'r')
      formData.append('dialog_name', 'yagiprime_mypage_dialog')
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')

      if (this.caratJobInfo.type == 'other_recommender') {
        formData.append('recommended_job_id', this.caratJobInfo.other_recommender_recommended_job_id)

      } else {
        formData.append('recommended_job_id', this.caratJobInfo.recommended_job_id)

      }
      formData.append('occupation', 'アルバイト')

      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applicationYagiprimecarat, formData, { timeout: 60000 })
        .then(function (response) {
          app.caratJobInfo.applied_date = '2024'
          app.$message({
            message: '応募しました。',
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    cancelYagiprimeCarat: function () {
      // console.error('closeDialog')
      const app = this
      const formData = new FormData()
      formData.append('recommended_job_id', this.caratJobInfo.recommended_job_id)
      this.$axios
        .post(this.$varuna.endPoints.cancelRecommendedJob, formData, { timeout: 60000 })
        .then(function (response) {
          app.caratJobInfo.cancel_date = '2024'
          app.$modal.hide('yagiprime-carat-dialog')
        })
        .catch(function (error) {
        }).finally(function () {
        })

    }
  },
  beforeMount: function () {
    this.$eventHub.$on('popstate', this.closeDialog)
    this.$eventHub.$on('open-yagiprime-carat-dialog', this.openYagiprimeCaratDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('popstate', this.closeDialog)
    this.$eventHub.$off('open-yagiprime-carat-dialog', this.openYagiprimeCaratDialog)
  }
}
</script>
